import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { merge } from "@modern-js/runtime-utils/merge";
import { createPluginManager } from "../../manager";
import { initPluginAPI } from "../../runtime/api";
import { createRuntimeContext, initRuntimeContext } from "../../runtime/context";
var createRuntime = function() {
  var init = function init2(options) {
    pluginManager.clear();
    initOptions = options;
    var allPlugins = options.plugins, handleSetupResult = options.handleSetupResult;
    pluginManager.addPlugins(allPlugins);
    var plugins = pluginManager.getPlugins();
    var context = createRuntimeContext({
      runtimeContext: initRuntimeContext(),
      config: initOptions.config,
      plugins
    });
    var pluginAPI = initPluginAPI({
      context,
      pluginManager,
      plugins
    });
    context.pluginAPI = pluginAPI;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var plugin = _step.value;
        var _plugin_setup;
        var setupResult = (_plugin_setup = plugin.setup) === null || _plugin_setup === void 0 ? void 0 : _plugin_setup.call(plugin, pluginAPI);
        if (handleSetupResult) {
          handleSetupResult(setupResult, pluginAPI);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return {
      runtimeContext: context
    };
  };
  var run = function run2(options) {
    var runtimeContext = init(options).runtimeContext;
    var configs = runtimeContext.hooks.config.call().filter(function(config) {
      return Boolean(config);
    });
    runtimeContext.config = merge.apply(void 0, [
      {}
    ].concat(_to_consumable_array(configs), [
      runtimeContext.config || {}
    ]));
    return {
      runtimeContext
    };
  };
  var initOptions;
  var pluginManager = createPluginManager();
  return {
    run
  };
};
export {
  createRuntime
};
